<template>
  <canvas class="soc-canvas" ref="procanvas"></canvas>
</template>
<script>
export default {
  name:'pi-soc-canvas',
  data(){
    return{

    }
  },
  props:{
    soc : {
      type: Number,
      default: 100
    }
  },
  methods: {
    process(ring) {
      var scale = 4;
      var canvas = this.$refs.procanvas;
      var canvasW = ring.canvasW * scale;
      var canvasH = ring.canvasH * scale;

      canvas.width = canvasW;
      canvas.height = canvasH;

      var context = canvas.getContext('2d');
      var center = [canvasW / 2, canvasH / 2];
      var borderWidth = ring.bdWidth * scale;
      var size = 14 * scale;
      var r = canvasW / 2 - borderWidth / 2 - 1; // 因内层canvas的宽度和外层相等，所以需要减去圆环的宽度

      // 外层圆环

      var percent = ring.percent;

      context.clearRect(0, 0, canvasW, canvasH); // 清除canvas
      // 开始画一个灰色的圆
      // context.save();
      // context.beginPath();
      // context.lineWidth = borderWidth;
      // context.strokeStyle = ring.bgcolor;
      // context.arc(center[0], center[1], r, 0, 2 * Math.PI, false);
      // context.stroke();
      // context.restore();
      // 设置渐变色,做了简单的判断传入的是渐变色或者纯色

      context.strokeStyle = ring.strokeColor;

      // 此处是添加圆环内部的文字
      context.save();
      context.beginPath();
      context.font = size + 'px Arial';
      context.fillStyle = ring.strokeColor;
      context.textAlign = 'center'; // 基于基线水平居中，垂直目前没好的方法，有请告知

      context.fillText(ring.centerText, center[0], center[1] + 20);
      context.restore();

      context.save();
      context.beginPath();
      context.lineWidth = borderWidth;
      context.arc(
        center[0],
        center[1],
        r,
        (Math.PI / 180) * -90,
        ((2 * (percent - 25)) / 100) * Math.PI,
        false
      );
      context.lineCap = 'round';
      context.stroke();
      context.restore();
    },
    init(){
      var docEl = document.documentElement;
      var fontSize = parseInt(docEl.style.fontSize);
      var canvasW = fontSize * 1;
      var bdWidth = fontSize * 0.1;

      var strokeColor = '#FFA244';
      var percent = this.soc;
      var centerText = percent + '%';
      this.process({
        canvasW: canvasW, // canvas的width
        canvasH: canvasW, // canvas的height
        bdWidth: bdWidth, // 圆环的宽
        bgcolor: '#ddd', // 圆环的背景颜色
        strokeColor: strokeColor, // 纯色,没渐变写

        percent: percent, // 转过的百分比
        centerText: centerText
      });
    }
  },
  mounted() {
    this.$nextTick(()=>{
      this.init();
    })
  },
}
</script>
<style lang="less">
  .soc-canvas{
    width: 100%;
    height: 100%;
  }
</style>